import React, { useEffect, useState } from 'react';
import { GetStaticPropsContext } from "next";
import { createSubscription } from "components/hooks/usePreview";
import { withAppLayout } from "components/core/withAppLayout";
import TextBlock, { ITextBlock } from "blocks/text/TextBlock";
import Container from "components/core/Container";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../../next-i18next.config";
import { getBalanceChecker } from "queries/BalanceChecker";
import algoliasearch from 'algoliasearch/lite';
import { Hits, InstantSearch } from "react-instantsearch-hooks-web";
import { Hit } from "components/giftcard/Hit";
import { CustomSearchBox } from "components/giftcard/SearchBox";
import getConfig from "next/config";
import useHttp from "http/useHttp";
import useRouter from "components/hooks/useRouter";
import Divider from "components/elements/Divider";
import useTrans from "components/hooks/useTrans";

export async function getStaticProps(context: GetStaticPropsContext) {
    const query = {
        query: getBalanceChecker(context.locale),
        preview: context.preview,
        withAppData: true,
        locale: context.locale
    };

    const data = await createSubscription(context, query);

    return {
        props: {
            data: data,
            seo: data.initialData.balanceChecker.seo,
            appData: {
                ...data.initialData.header,
                ...data.initialData.footer,
            },
            ...(await serverSideTranslations(context.locale, ['common'], nextI18NextConfig)),
        }
    };
}

type Props = {
    balanceChecker: {
        content: ITextBlock,
    }
};

function Index({ balanceChecker }: Props) {
    const textBlock = balanceChecker.content[0];
    const { publicRuntimeConfig } = getConfig();
    const { t } = useTrans();
    const http = useHttp();
    const router = useRouter();
    const [keyword, setKeyword] = useState("");

    useEffect(() => {
        let hash = router.asPath.replace("/giftcard", "");
        hash = hash.replace("?hash=", "");

        if (typeof hash == 'string' && hash.length > 4) {
            http.get(`/giftcards/${hash}/is-unique`)
                .then((res) => {
                    const data = JSON.parse(res.data);
                    if (data.data.is_unique) {
                        window.location.replace(data.data.url);
                    }
                })
                .catch(console.log);
        }

    }, []);

    const searchClient = algoliasearch('7S1EW9UPP3', '308ec980e36be35b57931eb7c05451a8');

    let indexName = `local_website_giftcard_custom_app_search`;

    if (publicRuntimeConfig.ENV === 'develop') {
        indexName = `development_website_giftcard_custom_app_search`;
    }

    if (publicRuntimeConfig.ENV === 'production') {
        indexName = `production_website_giftcard_custom_app_search`;
    }

    return (
        <>
            <section className={"w-full"}>
                <TextBlock {...textBlock} />
            </section>
            <section>
                <Container>
                    <div className={"w-full mb-20"}>
                        <InstantSearch
                            searchClient={searchClient}
                            indexName={indexName}
                        >
                            <CustomSearchBox
                                {...searchClient}
                                keyword={keyword}
                                setKeyword={setKeyword}
                            />

                            <div className={"py-4"}>
                                <Divider/>
                            </div>

                            {keyword.length > 2 && (
                                <Hits hitComponent={(props) => <Hit {...props} label={t('checkBalance')}/>}/>
                            )}
                        </InstantSearch>
                    </div>
                </Container>
            </section>
        </>
    );
}

export default withAppLayout(Index);